import { useState, ReactNode } from "react"
import { Head } from "@inertiajs/react"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../components/ui/card"
import { Button } from "../../components/ui/button"
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "../../components/ui/dialog"
import { Plus } from "lucide-react"
import AddProject from "./AddProject"
import ProjectsList from "./ProjectsList"
import AdminLayout from "../../layouts/AdminLayout"

const AdminProjects = () => {
  const [dialogOpen, setDialogOpen] = useState(false)

  return (
    <>
    <Head title="Projects" />

    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
          <DialogTrigger asChild>
            <Button>
              <Plus className="h-4 w-4 mr-2" />
              Add New Project
            </Button>
          </DialogTrigger>
          <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle>Add New Project</DialogTitle>
              <DialogDescription>
                Fill out the form below to create a new project. All fields marked with * are required.
              </DialogDescription>
            </DialogHeader>
            <AddProject onSuccess={() => setDialogOpen(false)} />
          </DialogContent>
        </Dialog>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>All Projects</CardTitle>
          <CardDescription>
            View and manage all your projects with pagination
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ProjectsList />
        </CardContent>
      </Card>
    </div>

    </>
  )
}

AdminProjects.layout = (page: ReactNode) => <AdminLayout>{page}</AdminLayout>

export default AdminProjects
